import script from "./SkuSwapPlacementDecisions.vue?vue&type=script&setup=true&lang=js"
export * from "./SkuSwapPlacementDecisions.vue?vue&type=script&setup=true&lang=js"

import "./SkuSwapPlacementDecisions.vue?vue&type=style&index=0&id=e2fa81ba&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2fa81ba"]])

export default __exports__